import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'react-bootstrap';
import ContainerCol from './ContainerCol';
import ContainerRow from './ContainerRow';

import withIdContext from '../../decorators/withIdContext';

/** Provides the width constraints on responsive widths.
 * Provides padding so the content doesn't touch the edge of the browser.
 * It is not to be a child of an another container. */
export const Container = ({ children, fluid, className }) => (
  <Grid fluid={fluid} className={className}>
    {children}
  </Grid>
);

Container.Row = ContainerRow;
Container.Col = ContainerCol;

Container.propTypes = {
  /** Anything to render. */
  children: PropTypes.node,
  /** Turns layout into a full-width layout. */
  fluid: PropTypes.bool,
  /** Allows custom className customization on Grid component. */
  className: PropTypes.string,
};

Container.defaultProps = {
  children: null,
  fluid: false,
  className: null,
};

export default withIdContext()(Container);
